var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center page",attrs:{"id":"progress"}},[_c('h2',[_vm._v("Deze pagina is nog in ontwikkeling.")])])}]

export { render, staticRenderFns }